module.exports = __webpack_public_path__ + "static/media/foilSilver.df4b5871.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invitations/foilSilver.svg
// module id = 558
// module chunks = 51